import { post } from '@/http/request'

/**
 * 模板下载
 * @returns {Promise<AxiosResponse<any>>}
 */
export const fetchTemplateDownload = () => post('/vip/excel/download/package/number/template', null, { responseType: 'blob' })
